import { render, staticRenderFns } from "./LinkedinIcon.vue?vue&type=template&id=16cd51a0&"
import script from "./LinkedinIcon.vue?vue&type=script&lang=js&"
export * from "./LinkedinIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports